<template>
  <header class="app-header navbar" :style="{ backgroundColor: coloreSfondo, color: coloreTesto }">
    <button
      class="navbar-toggler mobile-sidebar-toggler d-lg-none"
      type="button"
      @click="mobileSidebarToggle"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <b-link
      class="navbar-brand"
      :to="{ name: 'Dashboard' }"
      :style="'background-color:' + coloreSfondo + ''"
    ></b-link>
    <button
      class="navbar-toggler sidebar-toggler d-md-down-none mr-auto"
      type="button"
      @click="sidebarToggle"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <p>{{ projectModality }}</p>
    <b-navbar-nav class="ml-auto">
      <!--<b-nav-item class="d-md-down-none">
        <i class="fa fa-list"></i>
      </b-nav-item>
      <b-nav-item class="d-md-down-none">
        <i class="fa fa-map-marker"></i>
      </b-nav-item>-->
      <LanguageHeaderDropdown></LanguageHeaderDropdown>
      <HeaderDropdown :v-show="isAuthenticated && false" />
    </b-navbar-nav>
    <!--
    <button
      class="navbar-toggler aside-menu-toggler d-md-down-none"
      type="button"
      @click="asideToggle"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    -->
  </header>
</template>
<script>
import HeaderDropdown from "./HeaderDropdown.vue";
import LanguageHeaderDropdown from "./HeaderLanguageDropdown.vue";
import store from "../../store";
import dashboardService from "../../services/backend/dashboardService";
import colorsService from "../../services/backend/colorsService";
import generalService from "../../services/backendCipriani/generalService";
import $ from "jquery";

export default {
  name: "Header",
  components: {
    HeaderDropdown,
    LanguageHeaderDropdown
  },

  data() {
    return {
      fullName: "",
      appsList: [],
      coloreSfondo: "",
      coloreTesto: ""
    };
  },

  computed: {
    isAuthenticated() {
      var that = this;
      var ret = false;
      ret = that.$store.getters.isUserLogged;
      return ret;
    },
    projectModality() {
      var that = this;

      var modality = that.$store.getters.getProjectModality;
      var modStr = "";
      if (that.appsList.length > 0 && modality > 0) {
        modStr = that.appsList.find(el => el.id == modality).name;
      }

      var offerStr = "";
      var idOffer = that.$store.getters.getIdOffertaAttiva;
      if (idOffer > 0) {
        var offerNr = that.$store.getters.getNrOffertaAttiva;
        var offerName = that.$store.getters.getNameOffertaAttiva;

        if (offerNr) {
          offerStr = offerStr + "[" + offerNr + "]";
        }

        if (offerName) {
          offerStr = offerStr + (offerNr ? " - " : "") + offerName;
        }
      }

      var ret = modStr + (modStr && offerStr ? " - " : "") + offerStr;
      return ret;
    }
  },

  mounted: function() {
    var that = this;
    that.fullName = that.$store.getters.loggedUserInfo.fullName;
    //colorsService.getColoriHeader().then(function(data) {
    var colorList = colorsService.getColoriHeader();
    that.coloreSfondo = colorList[0]; // 2 elementi
    that.coloreTesto = colorList[1];
    //});
    dashboardService.getApps().then(function(data) {
      data.forEach(app => {
        app.modalities.forEach(modality => {
          that.appsList.push({
            id: modality.id,
            name: app.name + ", " + that.uniTranslation(modality.name)
          });
        });
      });
    });

    var local = document.querySelector("#CiprianiPath").value;

    generalService.getPathLogoBrandActiveCustomerProfile(local).then(function(data) {
      $(".app-header.navbar .navbar-brand").css("background-image", "url(" + data + ")"); //'url(H:/VB_WEB/UnilabWorld/Microservices/UnilabApiCipriani/Content/CIAT/Logo2.jpg)');
      
      $(".app-header.navbar .navbar-brand").css("background-size", "100%");
    });
  },
  methods: {
    sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-hidden");
      store.dispatch("toggleSidebarProperty");
    },
    sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-minimized");
    },
    mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("sidebar-mobile-show");
      store.dispatch("toggleSidebarProperty");
    },
    asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle("aside-menu-hidden");
      store.dispatch("toggleAsideMenuProperty");
    }
  }
};
</script>
